// API
import api from '../../api'

// Utilities
import isEmpty from '../../utility/isEmpty'
import Logger from '../../utility/loggerUtil'

export default {
  async updateIncome (context, incomeData) {
    try {
      const response = await api.applicationIncome.update(
        incomeData.incomeList,
        incomeData.isCustomerInBankruptcy,
        incomeData.activeDuty,
        incomeData.employmentPerWeek,
        incomeData.employmentLength,
        incomeData.existingFlexLoan,
        context.rootState.applicationCustomer.applicationId
      )

      if (!isEmpty(response?.incomeList) || !isEmpty(incomeData.incomeList)) {
        context.commit('updateIncomeList', {
          incomeList: response?.incomeList || incomeData.incomeList
        })
      }

      context.commit('applicationCustomer/updateCustomerInfo', {
        isCustomerInBankruptcy: incomeData.isCustomerInBankruptcy,
        activeDuty: incomeData.activeDuty,
        employmentPerWeek: incomeData.employmentPerWeek,
        employmentLength: incomeData.employmentLength,
        existingFlexLoan: incomeData.existingFlexLoan
      }, { root: true })
    } catch (error) {
      Logger.error('Error on applicationIncome/updateIncome')
      Logger.debug(error)
      throw error
    }
  },

  async deleteIncome (context, data) {
    try {
      const selectedIncome = context.state.incomeList[data.incomeIndex]

      if (isEmpty(selectedIncome) || isEmpty(selectedIncome.incomeId)) { // If income does not exist or was not saved to unitas, no need to set as inactive
        context.commit('deleteIncome', {
          incomeIndex: data.incomeIndex
        })
        return
      }

      context.commit('setIncomeInactive', {
        incomeIndex: data.incomeIndex
      })

      const response = await api.applicationIncome.update(context.state.incomeList, undefined, undefined, undefined, undefined, undefined, context.rootState.applicationCustomer.applicationId)

      if (!isEmpty(response?.incomeList)) {
        context.commit('updateIncomeList', {
          incomeList: response?.incomeList
        })
      } else {
        context.commit('deleteIncome', {
          incomeIndex: data.incomeIndex
        })
      }
    } catch (error) {
      Logger.error('Error on applicationIncome/deleteIncome')
      Logger.debug(error)
      throw error
    }
  },

  async updateExpenses (context, expenseData) {
    try {
      context.commit('updateExpenses', {
        rent: expenseData.rent,
        utilities: expenseData.utilities,
        insurance: expenseData.insurance,
        otherExpenses: expenseData.otherExpenses,
        signatureInitials: expenseData.signatureInitials
      }, { root: true })

      await api.applicationIncome.updateExpenses(
        context.rootState.applicationCustomer.applicationId,
        context.getters.grossMonthlyIncome,
        context.getters.netMonthlyIncome,
        context.getters.grossMonthlyExpenses,
        expenseData.rent,
        expenseData.utilities,
        expenseData.insurance,
        expenseData.otherExpenses
      )
    } catch (error) {
      Logger.error('Error on applicationIncome/updateExpenses')
      Logger.debug(error)
      throw error
    }
  }
}
